import { isEmpty, isString, isNull } from 'lodash-es';

// eslint-disable-next-line func-names
const validator = (() => {
  const isValidEmail = (email) => {
    if (isNull(email) || email === '') {
      return true;
    }

    if (!isString(email)) {
      return false;
    }

    // Replace with modified version of https://stackoverflow.com/a/46181/279262
    // TLD (top level domain) can be up to 63 characters (see https://stackoverflow.com/a/22038535/279262)
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-z\-0-9]+\.)+[a-z]{2,63}))$/
      );
  };

  const isValidPassword = (password) => {
    if (isEmpty(password) || !isString(password)) {
      return false;
    }

    const pwRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,32}$/;

    return !!password.match(pwRegex);
  };

  const invalidPasswordMessage = () =>
    'Password length be between 8 and 15 characters, and must include at least one uppercase letter, one digit and one special character';

  const isValidEircode = (eircode) => {
    if (isEmpty(eircode) || !isString(eircode)) {
      return false;
    }

    const eircodeRegex = /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/i;

    return !!eircode.match(eircodeRegex);
  };

  const isValidPhoneNumber = (phone) => {
    if (isEmpty(phone)) {
      return false;
    }

    const phoneRegex = /^\+\d{1,15}$/;

    return !!phone.match(phoneRegex);
  };

  return {
    isValidEmail,
    isValidPassword,
    invalidPasswordMessage,
    isValidEircode,
    isValidPhoneNumber
  };
})();

export default validator;
